import { Injectable } from "@angular/core";
import { AbstractControl, ValidatorFn } from "@angular/forms";
import { MonetaryService } from "../../core/services/monetary.service";

@Injectable({
  providedIn: "root"
})
export class ValidatorsService {
  constructor(private monetaryService: MonetaryService) {}

  biggerOrEqualValidator(carWorkshopPrice, clientPrice): ValidatorFn {
    return (c: AbstractControl): { [key: string]: any } | null => {
      const carWorkshopPriceMonetary =
        this.monetaryService.monetaryStringToFloat(carWorkshopPrice);
      const clientPriceMonetary =
        this.monetaryService.monetaryStringToFloat(clientPrice);

      if (carWorkshopPriceMonetary > clientPriceMonetary) {
        return { biggerOrEqual: true };
      } else {
        return null;
      }
    };
  }
}
